module.exports = __webpack_public_path__ + "static/media/bz.bac9ee9e.svg";